export const PageDataState = {
    Searchs: {
        name: {
            type: 'text',
            id: 'name',
            label: 'ชุดข้อมูล',
            value: '',
            placeholder: 'ชุดข้อมูล',
        },
        // academy_id: {
        //     type: 'select',
        //     id: 'academy_id',
        //     label: 'สถานศึกษา',
        //     value: '',
        //     placeholder: 'สถานศึกษา',
        // },  
        start_import_date: {
            type: 'text',
            id: 'start_import_date',
            label: 'วันที่นำเข้า',
            value: '',
        },
        end_import_date: {
            type: 'text',
            id: 'end_import_date',
            label: 'ถึง',
            value: ''
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            placeholder: 'สถานะ',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: '',
            value: '',
            validator: {
                type: 'text',
                required: false
            },
            error: { status: null, msg: '' }
        },
        name: {
            type: 'text',
            id: 'name',
            label: 'ชุดข้อมูล',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        // academy_id: {
        //     type: 'select',
        //     id: 'academy_id',
        //     label: 'สถานศึกษา',
        //     value: '',
        //     validator: {
        //         type: 'text',
        //         required: true
        //     },
        //     error: { status: null, msg: '' }
        // },
        import_data: {
            type: 'file',
            id: 'import_data',
            label: 'ไฟล์ข้อมูล',
            fileId: '',
            fileName: '',
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,.csv"
            },
            error: { status: null, msg: '' }
        },
        import_date: {
            type: 'text',
            id: 'import_date',
            label: 'วันที่นำเข้า',
            value: '',
            validator: {
                type: 'datetime',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
    },
    InputGroup: {}
}